import { render, staticRenderFns } from "./InsuranceSectionForm.vue?vue&type=template&id=f96d430c"
import script from "./InsuranceSectionForm.vue?vue&type=script&lang=ts"
export * from "./InsuranceSectionForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports